export default __webpack_public_path__ + "static/media/hook.1f953296.svg";